<template>
    <div class="row empty-section">
        <div class="col col-12">
            <div class="detail-card">
                <div class="row align-items-center">
                    <div class="col col-1">
                        <b-icon icon="x-octagon" font-scale="1.5" shift-h="-4"/>
                    </div>
                    <div class="col">
                        <span v-html="message"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "empty-section",
    props: {
        message: { type: String },
    },
};
</script>

<style scoped lang="scss">
</style>